module.exports = __webpack_public_path__ + "img/img03.b4941e52.png";